import { ACCESS_RIGHTS, GENDER } from '../../resources/enums';
import { ICountry } from '../User';
import { IStaff } from './IStaff';

export class Staff {
  id: string;
  email: string;
  phone: string;
  phoneVerified: boolean;
  emailVerified: boolean;
  firstName: string;
  lastName: string;
  otherNames?: string;
  name?: string;
  fullName: string;
  address?: string;
  idType?: string;
  idNumber?: string;
  gender: GENDER | string;
  image: HTMLImageElement | string | File | undefined;
  dateOfBirth: Date | undefined;
  country?: ICountry;
  state: string | undefined;
  city: string | undefined;
  jobTitle: string | undefined;
  accessRight: ACCESS_RIGHTS;
  department?: string;
  createdOn?: string;
  createdBy?: string;
  updatedOn?: string;
  updatedBy?: string;
  role?: string;
  activated?: boolean;
  branchName?: string;
  companyType?: string;
  verified?: boolean

  constructor(Imodel: IStaff) {
    this.id = Imodel.id;
    this.email = Imodel.email;
    this.phone = Imodel.phone;
    this.firstName = Imodel.firstName;
    this.lastName = Imodel.lastName;
    this.name = Imodel.name;
    this.otherNames = Imodel.otherNames;
    this.fullName = Imodel.fullName ?? Imodel.name ?? `${this.firstName} ${this.lastName}`;
    this.address = Imodel.address;
    this.idType = Imodel.idType;
    this.idNumber = Imodel.idNumber;
    this.gender = Imodel.gender;
    this.image = Imodel.image ?? undefined;
    this.dateOfBirth = Imodel.dateOfBirth ? new Date(Imodel.dateOfBirth) : undefined;
    this.country = Imodel.country;
    this.state = Imodel.state ?? undefined;
    this.city = Imodel.city ?? undefined;
    this.jobTitle = Imodel.jobTitle;
    this.accessRight = Imodel.accessRight;
    this.department = Imodel.department;
    this.createdOn = Imodel.createdOn;
    this.createdBy = Imodel.createdBy;
    this.updatedOn = Imodel.updatedOn;
    this.updatedBy = Imodel.updatedBy;
    this.emailVerified = Imodel.emailVerified;
    this.phoneVerified = Imodel.phoneVerified;
    this.verified = Imodel.verified;
    this.role = Imodel.role;
    this.activated = Imodel.activated;
    this.branchName = Imodel.branchName;
    this.companyType = Imodel.companyType;
  }
}
